import { render } from "./PatientVisit.vue?vue&type=template&id=3c1bd6c6&scoped=true"
import script from "./PatientVisit.vue?vue&type=script&lang=js"
export * from "./PatientVisit.vue?vue&type=script&lang=js"

import "./PatientVisit.vue?vue&type=style&index=0&id=3c1bd6c6&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1bd6c6"]])

export default __exports__